import React from "react";
var __jsx = React.createElement;
import SingleRadioMD from "../../finance-checkout/FreeFinanceComponents/SingleRadioMD";
import stl from "./RadioButtonMD.module.css";
var RadioButtonMD = function RadioButtonMD(_ref) {
  var label = _ref.label,
    name = _ref.name,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    onChange = _ref.onChange,
    className = _ref.className,
    error = _ref.error,
    selected = _ref.selected;
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.RadioButtonMDContainer, className ? className : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("strong", null, label), options.length > 0 && /*#__PURE__*/React.createElement("div", null, options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(SingleRadioMD, {
      key: index,
      selected: selected && option.value == selected,
      onChange: onChange,
      name: name,
      value: option.value,
      title: option.title
    });
  })), error && /*#__PURE__*/React.createElement("span", {
    className: stl.error
  }, error));
};
export default RadioButtonMD;